import { GoldDivider, FloralOrnament } from "./Ornaments";

const PROGRAM = [
  { time: "11:00", title: "პარაგრაფი", note: "მაყარი არ დაიშვება" },
  { time: "14:00", title: "ბუკნარი „ორანჟერია“" },
  { time: "16:00", title: "გიკა სტუდიო" },
  { time: "18:00", title: "დარბაზი „ლიდერი“" },
];

export default function DayProgram() {
  return (
    <section data-testid="day-program-section" className="text-center">
      <FloralOrnament className="mx-auto mb-4 opacity-80" />
      <h2 className="text-xl font-medium tracking-wide text-[#292524] sm:text-2xl">
        დღის პროგრამა
      </h2>
      <div className="mt-3">
        <GoldDivider />
      </div>

      <ol className="relative mx-auto mt-9 max-w-xs space-y-7 border-l border-[#E5D5B8] pl-7 text-left">
        {PROGRAM.map((item, i) => (
          <li key={item.time} data-testid={`program-item-${i}`} className="relative">
            <span
              className="absolute -left-[33px] top-1.5 h-2.5 w-2.5 rounded-full bg-gradient-to-br from-[#E9D194] to-[#B8860B] shadow ring-4 ring-[#FDFBF5]"
              aria-hidden="true"
            />
            <p className="font-display text-sm tracking-[0.2em] text-[#B8860B]">{item.time}</p>
            <p className="mt-0.5 text-base text-[#44403C]">{item.title}</p>
            {item.note && (
              <p className="font-editorial mt-0.5 text-sm italic text-[#A1A1AA]">({item.note})</p>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
